import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './navbar.css';
import logo from './componenten/logo.png';
import LogoLicht from './componenten/Mindis-Logo-Licht.png';
import LogoOranje from './componenten/Mindis-Logo-Oranje.png';


function Navbar() {
    const [scrolled, setScrolled] = useState(false)
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const buttonRef = useRef(null);

    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        const handleClickOutside = (event) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target)
            ) {
                setMenuOpen(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    return (
        <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
            <div className="navbar-left">
                <Link to="/" className='logo'>
                    <img src={(scrolled || menuOpen) ? LogoOranje : LogoLicht} alt="Logo" className='LogoMindis' />
                </Link>

                <button 
                className={`hamburger ${scrolled ? 'hamburger-scrolled' : ''} ${menuOpen ? 'hamburger-menuopen' : ''}`} 
                onClick={toggleMenu} 
                ref={buttonRef}
                >
                    &#9776;
                </button>
            </div>

            <ul className={`navbar-tabs ${scrolled ? 'navbar-tabs-scrolled' : ''} ${menuOpen ? 'active' : ''}`} ref={menuRef}>
                <li><Link to="overons" onClick={() => setMenuOpen(false)}> Over ons</Link></li>
                <li><Link to="projecten" onClick={() => setMenuOpen(false)}> Projecten</Link></li>
                <a href='./contact' className="contactopnemen">Neem contact op met Mindis</a>
            </ul>
        </nav>
    );
}

export default Navbar;